import React, { useState, useEffect } from "react";
//import { Button, Form, Alert } from "react-bootstrap";
import {connect, useSelector} from 'react-redux';
import {styled} from '@mui/material/styles';
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
//import DataTable from 'react-data-table-component';
import Stack from '@mui/material/Stack';
import MaterialTable from "@material-table/core";
import Typography from '@mui/material/Typography';
import {MTableToolbar} from "@material-table/core";
//import ArrowDownward from '@material-ui/icons/ArrowDownward';
//import TextField from '@material-ui/core/TextField';

import * as actions from '../store/actions/index';
import * as actionTypes from '../store/actions/actionTypes';

//
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
//

const StyledChip = styled(Chip)(({theme}) => ({
    fontSize: 12,
    "& .MuiChip-label":{
      padding: '2px 5px 1px'
    },
    margin: '0px',
    borderRadius: '1px',
    color: '#fff'
}));

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

function TicketDetails(props) {

    const [dataRows, setDataRows] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [filterData, setFilterData] = useState([]);
    const ticketSelector = useSelector((state) => state.ticket.ticket);

    useEffect(()=>{
        //if (props.role === "admin") {
        //    props.onGetClientTransactionsAdmin(props.token, props.client);
        //} else if (props.role === "manager") {
        //    props.onGetClientTransactionsSuperReseller(props.token, props.client);
        //} else if (props.role === "reseller"){
        //    props.onGetClientTransactionsReseller(props.token, props.client);
        //} else {
        props.onInitializeAddTicketDetail(); 
        if (props.role === "admin"){
            props.onGetTicketDetailsAdmin(props.token, props.currentTicketId);
        } else if(props.role === "reseller"){
            props.onGetTicketDetailsReseller(props.token, props.currentTicketId);
        } else if(props.role === "manager"){
            props.onGetTicketDetailsSuperReseller(props.token, props.currentTicketId);
        } else {
            props.onGetTicketDetails(props.token, props.currentTicketId);
        }  
    },[]);

    useEffect(() => {
        if (props.isErrorAddTicketDetail){
            var errorMessage = '' + props.isErrorAddTicketDetail;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
            props.onInitializeAddTicketDetail();
        }
    }, [props.isErrorAddTicketDetail]);

    // const spinner = (
    //     <Spinner
    //         as="span"
    //         animation="border"
    //         size="sm"
    //         role="status"
    //         aria-hidden="true"
    //     />
    // );
    //
    // const composeTransactionMessage = (t) => {
    //     let desc = '';
    //     if ('description' in t){
    //         desc = ':: ' + t.description;
    //     }
    //     let expiry = '';
    //     if ('expiry' in t){
    //         expiry = ', expiry ' + moment(t.expiry).format('MMM Do YYYY');
    //     }
    //     return <p><b>{moment(t.created).format('MMM Do YYYY hh:mm a')}</b>: {t.type} {t.credits} credit(s) {expiry} {desc}</p>
    // };

    let detailsData = [];

    useEffect(() => {
        if (props.details && props.details.length){
            detailsData = props.details.map((t) => {
                //console.log('inside client map', client);
                return {
                    date: moment(t.created).format('YYYY-MM-DD hh:mm a'),
                    description: t.description,
                    status: t.status,
                    createdBy: t.createdBy
                };
            });
            setDataRows(detailsData);
            setFilterData(detailsData);
            console.log('details data', detailsData);
        }
    },[props.details]);

    useEffect(() => {
        //console.log('insided useEffect', filterText);
        if (dataRows && dataRows.length){
            //console.log('filter data', clientsData);
            let data = dataRows.filter(item => {
                if (item.description && item.description.toLowerCase().includes(filterText.toLowerCase())) {
                    return true;
                } else if (item.type && item.type.toLowerCase().includes(filterText.toLowerCase())) {
                    return true;
                } else {
                    return false;
                }
            });
            setFilterData(data);
        }

    }, [filterText]);

    const sortIcon = <ArrowDownward />;

    const dataColumnsMaterial = [

        {
            title: 'Date',
            field: 'date',
            defaultSort: 'desc',
            editable: 'never',
            //render: (rowData) => {rowData.type},
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            },
            width: "16%"
        },
        {
            title: 'Description',
            field: 'description',
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            },
            render: (rowData) => {
                if (rowData.createdBy === 'Me') {
                    return (
                        <Stack direction="row" spacing={1}>
                            {(rowData.status === 1) ? <StyledChip label="CLOSED" sx={{backgroundColor: '#f44336'}} size="small"/> : ''}
                            <StyledChip label={(props.role==="admin") ? ticketSelector.name : rowData.createdBy} sx={{backgroundColor: '#4caf50'}} size="small"/>
                            <Typography sx={{fontSize:13}} variant="subtitle1" gutterBottom component="div">
                            {rowData.description}
                            </Typography>
                        </Stack>
                        );
                } else {
                    return (
                        <Stack direction="row" spacing={1}>
                            {(rowData.status === 1) ? <StyledChip label="CLOSED" sx={{backgroundColor: '#f44336'}} size="small"/> : ''}
                            <StyledChip label={rowData.createdBy} sx={{backgroundColor: '#1750ad'}} size="small"/>
                            <Typography sx={{fontSize:13}} variant="subtitle1" gutterBottom component="div">
                            {rowData.description}
                            </Typography>
                        </Stack>
                        );
                }
            }
        },
        
        // {
        //     title: 'Status',
        //     field: 'status',
        //     hidden: isSmallOrLess,
        //     cellStyle: {
        //         padding: '6px'
        //     },
        //     render: (rowData) => {
        //         if (rowData.status === 'ACTIVE') {
        //             return <StyledChip label={rowData.status} sx={{backgroundColor: '#4caf50'}} size="small"/>;
        //         } else {
        //             return <StyledChip label={rowData.status} sx={{backgroundColor: '#f44336'}} size="small"/>;
        //         }
        //     }
        // }
    ];

    const setTicketDetail = async (rowData) => {
        console.log('ticket detail data', rowData);
        console.log('current ticket id', props.currentTicketId);
        //props.onSetTicket(ticketId); //client name
        let data = {
            id: props.currentTicketId,
            description: rowData.description
        }
        console.log('ticket add data', data);
        if (props.role === "admin"){
            await props.onAddTicketDetailAdmin(props.token, data);
            await props.onGetTicketDetailsAdmin(props.token, props.currentTicketId);
        } else if(props.role === "reseller"){
            await props.onAddTicketDetailReseller(props.token, data);
            await props.onGetTicketDetailsReseller(props.token, props.currentTicketId);
        } else if(props.role === "manager"){
            await props.onAddTicketDetailSuperReseller(props.token, data);
            await props.onGetTicketDetailsSuperReseller(props.token, props.currentTicketId);
        } else {
            await props.onAddTicketDetail(props.token, data);
            await props.onGetTicketDetails(props.token, props.currentTicketId);
        }
        
        //props.history.push('/updateticket');
        //setClient(client);
    };

    // editable={{
    //     onRowAdd: newData =>
    //       new Promise((resolve, reject) => {
    //         setTimeout(() => {
    //           //setData([...data, newData]);
    //           console.log('new data', newData);

    //           resolve();
    //         }, 1000)
    //       }),
    //   }}

    return (
        <Grid container spacing={2}>
            <Grid xs={12} md={12} item>
                    <Card>
                        <CardHeader 
                            title="Details"
                            subheader="Add additional details on an active ticket" 
                            titleTypographyProps={{
                                fontSize: 17,
                                fontWeight: 'bold'
                            }} 
                            subheaderTypographyProps={{
                                fontSize: 14,
                            }}
                        />
                        <Divider variant="middle" />
                        <CardContent sx={{p:1}}>
                            <MaterialTable
                                icons={tableIcons}
                                columns={dataColumnsMaterial}
                                data={filterData}
                                editable={{
                                    onRowAdd: ticketSelector.status === 0 ? newData => 
                                    new Promise((resolve, reject) => {
                                                setTimeout(() => {
                                                  //setData([...data, newData]);
                                                  console.log('new data', newData);
                                                  setTicketDetail(newData)      
                                                  resolve();
                                                }, 1000)
                                              }) : undefined,
                                  }}
                                title=""
                                options={{
                                    pageSize: 10,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [10, 20, 30, 40, 50, 100],
                                    padding: "dense",
                                    actionsColumnIndex: -1,
                                    headerStyle: {padding: '5px', fontWeight: 'bold', fontSize: 13},
                                    tableLayout: "auto",
                                }}
                            
                            />
                        </CardContent>
                    </Card>
            </Grid>
        </Grid>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onGetTicketDetails: (token, id) => dispatch(actions.getTicketDetails(token, id)),
        onAddTicketDetail: (token, data) => dispatch(actions.addTicketDetail(token, data)),
        onGetTicketDetailsAdmin: (token, id) => dispatch(actions.getTicketDetailsAdmin(token, id)),
        onAddTicketDetailAdmin: (token, data) => dispatch(actions.addTicketDetailAdmin(token, data)),
        onGetTicketDetailsReseller: (token, id) => dispatch(actions.getTicketDetailsReseller(token, id)),
        onAddTicketDetailReseller: (token, data) => dispatch(actions.addTicketDetailReseller(token, data)),
        onGetTicketDetailsSuperReseller: (token, id) => dispatch(actions.getTicketDetailsSuperReseller(token, id)),
        onAddTicketDetailSuperReseller: (token, data) => dispatch(actions.addTicketDetailSuperReseller(token, data)),
        onInitializeAddTicketDetail: () => dispatch(actions.initializeAddTicketDetail()),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))
        //onGetClientTransactionsAdmin: (token, login) => dispatch(actions.getTransactionsAdminClient(token, login)),
        //onGetClientTransactionsSuperReseller: (token, login) => dispatch(actions.getTransactionsSuperResellerClient(token, login)),
        //onGetClientTransactionsReseller: (token, login) => dispatch(actions.getTransactionsResellerClient(token, login))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        currentTicket: state.ticket.ticket,
        currentTicketId: state.ticket.id,
        currentClientName: state.clientReducer.name,
        details: state.ticketDetails.details,
        isErrorAddTicketDetail: state.addTicketDetail.error,
        isLoadingTransactions: state.transactions.loading,
        isFailTransactions: state.transactions.error
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketDetails);